import type { ProcessedTicketData } from '../../../types/processedTicket';
import { normalizeGameImageUrl } from '../../../utils/normalizers/gameImageUrl';

type FetchImageAsBlob = (imageUrl: string) => Promise<string>;

export const getCaseSimulatorExportImageUrl = (imageUrl: string): string => {
  const normalizedUrl = normalizeGameImageUrl(imageUrl);
  if (!normalizedUrl) {
    return '';
  }

  try {
    const url = new URL(normalizedUrl, window.location.origin);
    const gamesImageMarker = '/games_images/';
    const markerIndex = url.pathname.lastIndexOf(gamesImageMarker);
    if (markerIndex >= 0) {
      const filename = url.pathname.slice(markerIndex + gamesImageMarker.length);
      if (filename && !filename.includes('/')) {
        return `/uploads/games_images/${encodeURIComponent(filename)}`;
      }
    }
  } catch {
    // Keep the normalized URL as a fallback for nonstandard external image URLs.
  }

  return normalizedUrl;
};

export const loadCaseSimulatorExportImages = async (
  packs: ProcessedTicketData[],
  fetchImageAsBlob: FetchImageAsBlob,
): Promise<Map<string, string>> => {
  const imageEntries = await Promise.all(packs.map(async (pack) => {
    const imageUrl = getCaseSimulatorExportImageUrl(pack.image_url);
    if (!imageUrl) {
      return [pack.pack_id, ''] as const;
    }

    const blobUrl = await fetchImageAsBlob(imageUrl);
    return [pack.pack_id, blobUrl] as const;
  }));

  return new Map(imageEntries);
};
